<ngb-accordion #a="ngbAccordion" activeIds="panel-0" [closeOthers]="true">
    <ngb-panel *ngFor="let panel of panels; let i = index;" [id]="'panel-' + i">
        <ng-template ngbPanelHeader let-opened="opened">
            <div class="panel-header-wrapper">
                <div class="panel-header">
                    <ng-container [ngTemplateOutlet]="headers.get(i) || null"></ng-container>
                </div>
                <button ngbPanelToggle class="panel-toggle">
                    {{ opened ? 'collapse' : 'expand' }}
                    <fa-icon [class.opened]="opened" [icon]="faAngleDown"></fa-icon>
                </button>
            </div>
        </ng-template>
        <ng-template ngbPanelContent>
            <ng-container [ngTemplateOutlet]="contents.get(i) || null"></ng-container>
        </ng-template>
    </ngb-panel>
</ngb-accordion>